module.exports = __webpack_public_path__ + "img/RBS04_4.98915733.jpg";